/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Try_AgainInputs */

const da_common_try_again = /** @type {(inputs: Common_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igen`)
};

/** @type {(inputs: Common_Try_AgainInputs) => LocalizedString} */
const en_common_try_again = da_common_try_again;

/**

* @param {Common_Try_AgainInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_try_again = /** @type {((inputs?: Common_Try_AgainInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Try_AgainInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_try_again(inputs)
	return /** @type {LocalizedString} */ ("Prøv igen")
});